import React from "react";
import { Box } from "@mui/material";
// You might need to import the image if using a bundler like Webpack/Vite
// or just reference it by public path if it's in public folder.
// Since we put it in src/assets, we should import it.
import logoSrc from "../../assets/logo.png"; 

const Logo = ({ sx, ...props }) => {
  return (
    <Box
      component="img"
      src={logoSrc}
      alt="SortlyBooks"
      sx={{
        height: 40,
        width: "auto",
        display: "block",
        ...sx,
      }}
      {...props}
    />
  );
};

export default Logo;
